import { dayjs } from '@utils/date'
import config from '@config'
import { DurationUnitType } from 'dayjs/plugin/duration'

const {
  date: { timeInputFormat: dateTimeInputFormat },
  video: { durationFormat: videoDurationFormat },
  publication: { publication },
} = config

export const formatDuration = (duration?: number): string => {
  if (typeof duration === 'undefined' || duration === null || duration < 0) {
    return '--:--'
  }

  return dayjs
    .duration(Number(duration), dateTimeInputFormat as DurationUnitType)
    .format(videoDurationFormat)
}

export const isVideoRecommendationsEnabled = (): boolean => {
  const isRomandie = publication === 'romandie'

  return !isRomandie
}
